module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    class: [{
      's-full-list-active': _vm.fullListActive
    }]
  }, [_c('h1', [_vm._v("The "), _c('span', [_vm._v("12 Seattle neighborhoods")]), _vm._v(" between "), _c('span', [_vm._v(_vm._s(_vm.startDate))]), _vm._v(" and "), _c('span', [_vm._v(_vm._s(_vm.endDate))]), _vm._v(" with the "), _c('strong', [_vm._v("highest")]), _vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "well collisions-filters"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "well-content"
  }, [_c('FilterDate', {
    attrs: {
      "default-option": {
        key: 'all',
        label: 'Since January 1st, 2006'
      }
    }
  }), _vm._v(" "), _c('FilterSubmitButton', {
    class: [{
      'is-loading': _vm.isLoading
    }],
    attrs: {
      "routeName": 'neighborhoodRanks',
      "routeParams": _vm.routeParams
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-grid l-grid-medium"
  }, [_c('Costs', {
    attrs: {
      "card-color": 'green',
      "card-icon": 'attach_money',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/costs/economic/desc',
        pageTitle: 'Seattle economic costs by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Economic costs',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        titleIcon: 'attach_money',
        color: 'green',
        prefix: '$',
        barColors: this.$store.getters.green.light.a
      },
      "getter": 'neighborhoodRanksView/costs/get',
      "title": 'Economic costs',
      "bar-color": this.$store.getters.green.light.a,
      "legend-color": 'green',
      "legend-link": 'neighborhood',
      "label-prefix": ' $'
    }
  }), _vm._v(" "), _c('TotalCollisions', {
    attrs: {
      "card-color": 'yellow',
      "card-icon": 'flare',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/totalcollisions/desc',
        pageTitle: 'Seattle total collisions by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Total collisions',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        titleIcon: 'warning',
        color: 'yellow',
        barColors: this.$store.getters.yellow.default
      },
      "getter": 'neighborhoodRanksView/totalCollisions/get',
      "title": 'Total collisions',
      "bar-color": this.$store.getters.yellow.default,
      "legend-color": 'yellow',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('Fatalities', {
    attrs: {
      "card-color": 'black',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/5/desc',
        pageTitle: 'Seattle fatalities by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Fatalities',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'black',
        barColors: this.$store.getters.black.dark.b
      },
      "getter": 'neighborhoodRanksView/fatalities/get',
      "title": 'Fatalities',
      "bar-color": this.$store.getters.black.dark.b,
      "legend-color": 'black',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('SeriousInjuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/4/desc',
        pageTitle: 'Seattle serious injuries by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Serious injuries',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'red',
        barColors: this.$store.getters.red.dark.b
      },
      "getter": 'neighborhoodRanksView/seriousInjuries/get',
      "title": 'Number of serious injuries',
      "bar-color": this.$store.getters.red.dark.b,
      "legend-color": 'red',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('Injuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/1/desc',
        pageTitle: 'Seattle injuries by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Injuries',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'red',
        barColors: this.$store.getters.red.dark.a
      },
      "getter": 'neighborhoodRanksView/injuries/get',
      "title": 'Number of injuries',
      "bar-color": this.$store.getters.red.dark.a,
      "legend-color": 'red',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PossibleInjuries', {
    attrs: {
      "card-color": 'red',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/3/desc',
        pageTitle: 'Seattle possible injuries by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'possible injuries',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'red',
        barColors: this.$store.getters.red.light.b
      },
      "getter": 'neighborhoodRanksView/possibleInjuries/get',
      "title": 'Collisions with possible injuries',
      "bar-color": this.$store.getters.red.light.b,
      "legend-color": 'red',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PeopleInvolved', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'person',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/personcount/desc',
        pageTitle: 'Seattle people involved by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'People involved',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'orange',
        barColors: this.$store.getters.orange.dark.a
      },
      "getter": 'neighborhoodRanksView/possibleInjuries/get',
      "title": 'Number of people involved',
      "bar-color": this.$store.getters.orange.dark.a,
      "legend-color": 'orange',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PeopleWalking', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'directions_walk',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/pedcount/desc',
        pageTitle: 'Seattle pedestrians involved by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Pedestrians involved',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'orange',
        barColors: this.$store.getters.orange.light.a
      },
      "getter": 'neighborhoodRanksView/peopleWalking/get',
      "title": 'Number of pedestrians involved',
      "bar-color": this.$store.getters.orange.light.a,
      "legend-color": 'orange',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PeopleBiking', {
    attrs: {
      "card-color": 'orange',
      "card-icon": 'directions_bike',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/pedcylcount/desc',
        pageTitle: 'Seattle people biking by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'People biking',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'orange',
        barColors: this.$store.getters.orange.light.b
      },
      "getter": 'neighborhoodRanksView/peopleBiking/get',
      "title": 'Number of people biking involved',
      "bar-color": this.$store.getters.orange.light.b,
      "legend-color": 'orange',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('DistractedDriving', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'visibility_off',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/inattentionind/desc',
        pageTitle: 'Seattle distracted driving by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Distracted driving',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'purple',
        barColors: this.$store.getters.purple.dark.a
      },
      "getter": 'neighborhoodRanksView/distractedDriving/get',
      "title": 'Cases of distracted driving',
      "bar-color": this.$store.getters.purple.dark.a,
      "legend-color": 'purple',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('UnderTheInfluence', {
    attrs: {
      "card-color": 'purple',
      "card-icon": 'blur_on',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/underinfl/desc',
        pageTitle: 'Seattle DUI by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Driving under the influence',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'purple',
        barColors: this.$store.getters.purple.light.a
      },
      "getter": 'neighborhoodRanksView/underTheInfluence/get',
      "title": 'Cases of DUI',
      "bar-color": this.$store.getters.purple.light.a,
      "legend-color": 'purple',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('PropertyDamageOnly', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'toll',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/severity/2/desc',
        pageTitle: 'Seattle property damage only by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Property damage only',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'blue',
        barColors: this.$store.getters.blue.light.a
      },
      "getter": 'neighborhoodRanksView/propertyDamageOnly/get',
      "title": 'Property damage only collisions',
      "bar-color": this.$store.getters.blue.light.a,
      "legend-color": 'blue',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('ParkedCarsHit', {
    attrs: {
      "card-color": 'blue',
      "card-icon": 'local_parking',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/hitparkedcar/desc',
        pageTitle: 'Seattle parked cars hit by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Parked cars hit',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'blue',
        barColors: this.$store.getters.blue.light.a
      },
      "getter": 'neighborhoodRanksView/parkedCarsHit/get',
      "title": 'Number of parked cars hit',
      "bar-color": this.$store.getters.blue.light.a,
      "legend-color": 'blue',
      "legend-link": 'neighborhood'
    }
  }), _vm._v(" "), _c('Speeding', {
    attrs: {
      "card-color": 'teal',
      "card-icon": 'fast_forward',
      "full-list-toggle-dispatch": 'neighborhoodRanksView/fullList/toggleActive',
      "full-list-options-dispatch": 'neighborhoodRanksView/fullList/setOptions',
      "full-list-options": {
        apiSlug: '/neighborhood/ranks/who/speeding/desc',
        pageTitle: 'Seattle speeding by neighborhood between ' + _vm.startDate + ' & ' + _vm.endDate,
        title: 'Speeding',
        ths: ['Rank', 'Neighborhood', 'Amount'],
        link: 'neighborhood',
        color: 'teal',
        barColors: this.$store.getters.teal.light.a
      },
      "getter": 'neighborhoodRanksView/speeding/get',
      "title": 'Cases of speeding',
      "bar-color": this.$store.getters.teal.light.a,
      "legend-color": 'teal',
      "legend-link": 'neighborhood'
    }
  })], 1), _vm._v(" "), _c('FullList', {
    attrs: {
      "getters": {
        active: 'neighborhoodRanksView/fullList/active',
        fetch: 'neighborhoodRanksView/fullList/fetch',
        filters: 'neighborhoodRanksView/fullList/filters',
        filterParams: 'neighborhoods=all',
        get: 'neighborhoodRanksView/fullList/get',
        options: 'neighborhoodRanksView/fullList/options',
        reset: 'neighborhoodRanksView/fullList/reset',
        toggleActive: 'neighborhoodRanksView/fullList/toggleActive'
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "well-title collisions-filters-title"
  }, [_c('span', [_vm._v("Filter collisions")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00244b21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/NeighborhoodRanks.vue
// module id = 415
// module chunks = 1